export const CART_REQUEST = "cart/request";
export const CART_ERROR = "cart/error";

export const GET_CART_SUCCESS = "cart/success";

export const ADD_TO_CART_SUCCESS = "addToCart/success";

export const DELETE_CART_SUCCESS = "deleteCart/success";

export const UPDATE_CART_SUCCESS = "updateCart/success";

export const ADD_ORDER_SUCCESS = "addOrder/success";
